<form [formGroup]="form">
  <div class="genericTableContainer">
    <div class="mat-elevation-z8">
      <div class="oneLine-reverse">
        <!-- SEARCH FIELD-->
        <mat-form-field class="float-right coloredBlack">
          <input [name]="'filter'" (keyup)="applyFilter($event.target.value)" class="inputMatField" matInput>
          <mat-placeholder class="placeholder">{{ tableauMessage.research | translate }}</mat-placeholder>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button *ngIf="isShalEnabled" type="button" (click)="createPresseSpecial()" class="mr-3 btn btn-outline-primary">
          <span class="oneLine">
            <mat-icon class="mr-2">add</mat-icon>
            <span>{{ preferenceMessages.modal_presse_spe_button_label | translate }}</span>
          </span>
        </button>
        <!-- Masqué suite au masquage SHAL/JAL -->
        <!-- <button *ngIf="mode===1 && isPrefActivated" type="button" (click)="createPrefDiffuseur()" class="mr-3 btn btn-outline-primary">
          <span class="oneLine">
            <mat-icon class="mr-2">add</mat-icon>
            <span>{{ preferenceMessages.modal_diffuseur_button_label | translate }}</span>
          </span>
        </button> -->
        <span class="viewTotalResults"> {{ paginator.pageIndex * paginator.pageSize + 1 }} {{ tableauMessage.separator | translate }} {{ ((paginator.pageIndex + 1) * paginator.pageSize) - avisNbPerPage  }} {{ tableauMessage.of | translate }} {{ paginator.length }} {{ tableauMessage.total | translate }}</span>
      </div>

      <table #myTable [dataSource]="tableDataSrc" class="mat-elevation-z8" formGroupName="tableDataCtrlName" id="generalTable"
        mat-table matSort multiTemplateDataRows>

        <!-- MAIN TABLE -->
        <ng-container *ngFor="let col of tableContent.tableCols; let i = index;" [matColumnDef]="col.columnDef">

          <!--HEADER OF MAIN TABLE-->
          <th [class]="col.classAlign" *matHeaderCellDef
            [disabled]="col.columnDef=='action' || col.columnDef=='develop' || col.columnDef=='radio' || col.columnDef=='checkbox'" mat-header-cell mat-sort-header>
            <div *ngIf="col.columnDef!='checkbox'" [style.color]="col.columnDef === 'develop' || col.columnDef === 'checkbox'? 'transparent' : 'initial'">{{ col.header }}</div>
          </th>

          <!-- NOT ACTION COLUMN -->
          <ng-container [ngSwitch]="col.columnDef">

            <ng-container *ngSwitchDefault>
              <!-- COLUMN TO ADD TO FORM WITH GroupName-->
              <ng-container *ngIf="col.columnDef != 'develop';else develop">
                <div *ngIf="isForm">
                  <td *matCellDef="let element;" [class]="col.classAlign" [formGroupName]="element.childRow ? element.idParent : element.id" mat-cell>
                    <div *ngIf="!element.childRow">
                      <label [for]="'input-' + element.id+'-'+element[col.columnDef]+'-'+col.header" hidden="true">{{ element.id }}{{ element[col.columnDef] }}{{ col.header }}</label>
                      <input [id]="'input-' + element.id+'-'+element[col.columnDef]+'-'+col.header" [name]="element.id"  [formControlName]="col.columnDef" [style.width.em]="element[col.columnDef]?.length*0.8"><span
                      *ngIf="col.columnDef == 'zonediffusion' && element.children?.length > 0" class="w-50">{{
                      tableauMessage.separator | translate }} {{ element.children?.length }} {{ tableauMessage.results |
                      translate }}</span></div>
                      <div [formGroupName]="'children'" *ngIf="element.childRow">
                        <div [formGroupName]="element.id">
                          <label [for]="'input-' + element.id+'-'+ element[col.columnDef]+'-'+col.header"hidden="true">{{ element.id }}{{ element[col.columnDef] }}{{ col.header }}</label>
                          <input [id]="'input-' + element.id+'-'+ element[col.columnDef]+'-'+col.header" [formControlName]="col.columnDef">
                        </div>
                      </div>

                  </td>
                </div>
                <!-- COLUMN TO SHOW DATA-->
                <div *ngIf="!isForm">
                  <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                    <span>{{ element[col.columnDef] }}</span>
                  </td>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'statut'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <span [ngClass]="{'published' : element.statut === 'Publié',
                                              'elaborated' : element.statut === 'Élaboré',
                                              'refused' : element.statut === 'Refusé',
                                              'sended' : element.statut === 'Envoyé'}" class="tag">
                  {{ element[col.columnDef] }}
                </span>
              </td>
            </ng-container>

            <!-- developper si enfants -->
            <ng-container *ngSwitchCase="'develop'">
              <div *ngIf="isForm">
                <td *matCellDef="let element;" [class]="col.classAlign" [formGroupName]="element.childRow ? element.idParent : element.id" mat-cell>
                  <span *ngIf="element.develop===true && !element.childRow">
                    <mat-icon *ngIf="!element.expanded" [attr.aria-label]="expand" aria-hidden="false">
                      keyboard_arrow_right</mat-icon>
                    <mat-icon *ngIf="element.expanded" [attr.aria-label]="expand" aria-hidden="false">
                      keyboard_arrow_down</mat-icon>
                  </span>
                  <div [formGroupName]="'children'" *ngIf="element.childRow">
                    <div [formGroupName]="element.id">

                    </div>
                  </div>
                </td>
              </div>
              <!-- COLUMN TO SHOW DATA-->
              <div *ngIf="!isForm">
                <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                  <span>{{ element[col.columnDef] }}</span>
                </td>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'action'">
              <!-- ACTION COLUMN -->
              <td [class]="col.classAlign" *matCellDef="let element;" class="action-link" mat-cell>
                <div *ngIf="!element.childRow;">
                <div *ngIf="col.actions.length<=2; then oneOrTwoActionsBlock; else manyActionsBlock"></div>
                </div>
                <!--ONE OR TWO ACTIONS BLOCK-->
                <ng-template #oneOrTwoActionsBlock>

                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm">
                    <div *ngFor="let action of col.actions" [formGroupName]="element.id" class="action-cell">
                      <div *ngIf="action.icon === 'info' ">
                        <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                          [attr.aria-label]='action.aria_label' [matTooltip]="action.description" aria-hidden="false">
                          {{action.icon}}</mat-icon>
                      </div>
                      <div *ngIf="action.icon !== 'info'">
                        <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                          [attr.aria-label]='action.aria_label' [matTooltip]="action.description" aria-hidden="false">
                          {{action.icon}}</mat-icon>
                      </div>
                      <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                        [attr.aria-label]='action.aria_label' [matTooltip]="action.description" aria-hidden="false">
                        {{action.icon}}</mat-icon>

                      <input (change)="getEvent(action,element,'INPUT_1')" *ngIf="action.icon=='checkbox'"
                        [attr.aria-label]='action.aria_label' [attr.id]="'INPUT_FORM_1A_checkBox' + element[uniqueKey]"
                        [attr.name]="'checkBox'+ element[uniqueKey]" [formControlName]="'checked'" type="checkbox" />
                    </div>
                    <mat-icon class="iconPresseUpdate ml-2" *ngIf="element.format==='Presse specialisée'"
                      (click)="updatePresse(element.id)">create</mat-icon>
                  </div>

                  <!-- COLUMN TO SHOW DATA 'CHOIX FORMULAIRE'-->
                  <div *ngIf="!isForm">

                    <div *ngFor="let action of col.actions" class="action-cell">
                      <mat-icon (click)="getEvent(action,element,'MATT_2')"
                        *ngIf="action.icon!='checkbox' && action.icon!='radio'" [attr.aria-label]='action.aria_label'
                        [matTooltip]="action.description" aria-hidden="false">
                        {{action.icon}}</mat-icon>
                      <input (change)="getEvent(action,element,'INPUT_2')"
                        *ngIf="action.icon=='checkbox' || action.icon=='radio'" [attr.aria-label]='action.aria_label'
                        [attr.id]="'INPUT_NOT_FORM_1A_checkBox' + element[uniqueKey]"
                        [attr.name]="'checkBox'+ element[uniqueKey]" class="checkbox" [type]="action.icon" />
                    </div>

                  </div>
                </ng-template>



                <!--MANY ACTIONS BLOCK-->
                <ng-template #manyActionsBlock>
                  <div [class]="col.classAlign" class="dropdown">
                    <a aria-expanded="false" aria-haspopup="true" class="horizon" data-toggle="dropdown" href="#"
                      id="dropdownMenuLink1" role="button">
                      <mat-icon aria-hidden="false">more_vertical</mat-icon>
                    </a>
                    <div id="dropdown-menu" aria-labelledby="dropdown-menu" class="dropdown-menu">
                      <div class="d-flex">
                        <mat-icon aria-hidden="false" class="ml-auto">close</mat-icon>
                      </div>
                      <div *ngFor="let action of col.actions" aria-labelledby="{{action.icon}}"
                        class="w-100 text-nowrap">
                        <a (click)="getEvent(action,element,'A_1')">{{action.description}}</a>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <ng-container *ngIf="element['actions'].length<=2 && element.childRow;">
                  <div *ngIf="isForm">
                    <mat-icon class="iconPresseUpdate ml-2" *ngIf="element.format==='Presse specialisée'"
                      (click)="updatePresse(element.id)">create</mat-icon>
                    <div *ngFor="let action of element['actions']" [formGroupName]="element.idParent"
                      class="action-cell">
                      <div [formGroupName]="'children'">
                        <div [formGroupName]="element.id">
                          <mat-icon (click)="getEvent(action,element,'MAT_3')" *ngIf="action.icon!='checkbox'"
                            [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                            aria-hidden="false">{{action.icon}}</mat-icon>
                          <input (change)="getEvent(action,element,'INPUT_3')" *ngIf="action.icon=='checkbox'"
                            [attr.aria-label]='action.aria_label'
                            [attr.id]="'INPUT_FORM_MA_checkBox' + element[uniqueKey]"
                            [attr.name]="'checkBox'+ element[uniqueKey]" [formControlName]="'checked'"
                            type="checkbox" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isForm">
                    <div *ngFor="let action of element['actions']" class="action-cell">
                      <mat-icon (click)="getEvent(action,element,'MAT_4')" *ngIf="action.icon!='checkbox'"
                        [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                        aria-hidden="false">{{action.icon}}</mat-icon>
                      <input (change)="getEvent(action,element,'INPUT_4')" *ngIf="action.icon=='checkbox'"
                        [attr.aria-label]='action.aria_label'
                        [attr.id]="'INPUT_NOT_FORM_MA_checkBox' + element[uniqueKey]"
                        [attr.name]="'checkBox'+ element[uniqueKey]" class="checkbox" type="checkbox" />
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="element['actions'].length>2 && element.childRow;">
                  <div [class]="element.classAlign" class="dropdown">
                    <a aria-expanded="false" aria-haspopup="true" class="horizon" data-toggle="dropdown"
                      href="#" id="dropdownMenuLink2" role="button">
                      <mat-icon aria-hidden="false">more_vertical</mat-icon>
                    </a>
                    <div aria-labelledby="dropdownMenuLink" class="dropdown-menu">
                      <div *ngFor="let action of element['actions']" aria-labelledby="{{action.description}}"
                        class="w-100">
                        <a (click)="getEvent(action,element,'A_1')">{{action.description}}</a>
                      </div>
                    </div>
                  </div>
                </ng-container>

              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <td [class]="col.classAlign" *matCellDef="let element;" class="action-link" mat-cell>
                <ng-container>
                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm && !element.childRow">
                    <div [formGroupName]="element.id" class="action-cell"
                      [matTooltip]="mapToolTip(element) | translate">
                      <input (change)="getEvent('checkbox',element,'INPUT_7')" [attr.aria-label]="'checkbox_selection'"
                        [attr.id]="'INPUT_FORM_1P_checkBox' + element.id"
                        [attr.name]="'checkBox'+ element.id"
									      [indeterminate]="selectionMap.get(element.id)?.hasValue() && !isAllChildSelected(element)"
                        [formControlName]="'checked'" type="checkbox" class="increase"/>
                    </div>
                  </div>
                  <div *ngIf="!isForm && !element.childRow">
                    <div class="action-cell">
                      <input (change)="getEvent('checkbox',element,'INPUT_8')" [attr.aria-label]="'checkbox_selection'"
                        [attr.id]="'INPUT_NOT_FORM_1P_checkBox' + element.id"
                        [attr.name]="'checkBox_primary_'+ element.id"
                        class="checkbox" [type]="'checkbox'" class="increase"/>
                    </div>

                  </div>

                  <div *ngIf="isForm && element.childRow">
                    <div [formGroupName]="element.id" class="action-cell">
                          <input (change)="getEvent('checkbox',element,'INPUT_5')"
                            [attr.aria-label]="'checkbox_selection'"
                            [attr.id]="'INPUT_FORM_PRIMARY_checkBox' + element.id"
                            [attr.name]="'checkBox_primary_'+ element.id"
                            class="checkbox" [formControlName]="'checked'" type="checkbox" class="increase"/>
                    </div>
                  </div>
                  <div *ngIf="!isForm && element.childRow">
                    <div class="action-cell">
                      <input (change)="getEvent('checkbox',element,'INPUT_6')" *ngIf="action.icon=='checkbox'"
                        [attr.aria-label]="'checkbox_selection'"
                        [attr.id]="'INPUT_NOT_FORM_PRIMARY_checkBox' + element.id"
                        [attr.name]="'checkBox_primary'+ element.id"
                        class="checkbox"
                        type="checkbox" class="increase"/>
                    </div>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'radio'">
              <td *matCellDef="let element;" class="action-link" mat-cell>
                <ng-container>
                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm">
                    <div [formGroupName]="element.id" class="action-cell">
                      <input (change)="getEvent('radio',element,'INPUT_7')" [attr.aria-label]="'radio_selection'"
                        [attr.id]="'INPUT_FORM_1P_radio' + element[uniqueKey]" [attr.name]="'radio'+ element[uniqueKey]"
                        [formControlName]="'radio'" type="radio" />
                    </div>
                  </div>
                  <div *ngIf="!isForm">
                    <div class="action-cell">
                      <input (change)="getEvent('radio',element,'INPUT_8')" [attr.aria-label]="'radio_selection'"
                        [attr.id]="'INPUT_NOT_FORM_1P_radio' + element[uniqueKey]"
                        [attr.name]="'radio_primary_'+ element[uniqueKey]" class="radio" [type]="'radio'" />
                    </div>

                  </div>
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- EXPANDABLE TABLE -->
        <tr *matHeaderRowDef="tableContent.displayedCols" mat-header-row></tr>
        <tr *matRowDef="let element; columns: tableContent.displayedCols; let k = dataIndex;"
        (click)="expandRow(element)" [class.child-detail-row]="(element.childRow || element.develop) && element.checked"
          mat-row ></tr>
      </table>
      <!-- PAGINATION-->
      <mat-paginator [pageSizeOptions]="[25, 20, 15, 10, 5]" class="coloredBlack" showFirstLastButtons (page)="handlePage($event)"></mat-paginator>
    </div>
  </div>
</form>
